import { render, staticRenderFns } from "./ns-register.vue?vue&type=template&id=3a0b197a&"
import script from "./ns-register.vue?vue&type=script&lang=js&"
export * from "./ns-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports